import axios from "axios";

const PDF_SERVICE_URL =
  import.meta.env.MODE && import.meta.env.MODE === "development"
    ? `${import.meta.env.VITE_REPORTS_API_URL}/reports/`
    : "/reports/";

const pdfClient = axios.create({
  baseURL: PDF_SERVICE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export { pdfClient };
